export * from "./amenities.component";
